<template>
	<Container>
		<Title>
			{{ $t('contratacion') }}
		</Title>
		<div>
			<div class="w-full flex justify-end">
				<div class="input-group pl-5 flex items-center">
					<input
						v-model="search"
						@keyup="onChangeSearch"
						type="text"
						class="
							sm:w-64
							form-control
							p-2
							border-b border-gray-400
							w-32
							focus:border-blue-500 focus:outline-none
						"
						placeholder="Buscar"
					/>
					<span>
						<img src="@/assets/img/buscar.svg" />
					</span>
				</div>
				<ButtonBlack>
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
			<ListTable
				:itemsTitles="itemsTitles"
				:items="contracts"
				:section="section"
				:itemsTable="itemsTable"
			/>
		</div>
	</Container>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		contracts: {
			query: gql`
				query ($user_id: bigint!, $search: String) {
					contracts(
						order_by: { contract_date: desc }
						where: {
							user_id: { _eq: $user_id }
							_or: [
								{ document: { _ilike: $search } }
								{ name: { _ilike: $search } }
								{ phone: { _ilike: $search } }
							]
						}
					) {
						id
						document
						name
						phone
						organization {
							name
						}
						responsable
						delegation
						status
						active
					}
				}
			`,
			variables() {
				return {
					user_id: this.$store.state.login.user.id
				}
			},
			update(data) {
				return data.contracts.map(item => ({
					id: item.id,
					document: item.document,
					name: item.name,
					phone: item.phone,
					organization: item.organization.name,
					responsable: item.responsable,
					delegation: item.delegation,
					status: this.$t(item.status),
					edit: true,
					active: item.active
				}))
			}
		}
	},
	data() {
		return {
			section: 'contrato',
			itemsTable: 'contracts',
			itemsTitles: [
				'Id',
				'CIF/NIF',
				'Nombre',
				'Telefono',
				'organizacion',
				'Responsable',
				'Delegation',
				'status'
			],
			search: ''
		}
	},
	components: { ListTable },
	methods: {
		onChangeSearch() {
			this.$apollo.queries.contracts.refetch({
				search: `%${this.search}%`
			})
		}
	}
}
</script>
